import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import type { OperatorSummary } from '@/api/auth';

interface AuthState {
  token: string | null;
  operator: OperatorSummary | null;
  setSession: (token: string, operator: OperatorSummary) => void;
  clear: () => void;
}

/**
 * Auth state lives in localStorage so a page reload keeps the session.
 * Magic-link tokens grant a 7-day server-side JWT (kind: 'hosting') —
 * that's our session length. If a 401 ever lands, the client interceptor
 * calls clear() and the router redirects to /login.
 *
 * Separate localStorage key from the inference console so the two
 * surfaces can coexist on the same machine without overwriting each
 * other's sessions.
 */
export const useAuthStore = create<AuthState>()(
  persist(
    set => ({
      token: null,
      operator: null,
      setSession: (token, operator) => set({ token, operator }),
      clear: () => set({ token: null, operator: null })
    }),
    { name: 'nurev-fleet-auth' }
  )
);

export const isAuthenticated = (): boolean => !!useAuthStore.getState().token;
